import { Box, Popper, TextField, useMediaQuery } from "@mui/material";
import { useRef, useState } from "react";
import TagUserPopover from "./TagUserPopover";

const TaggingTextField = ({
  value,
  handleInputChange,
  tagUserList,
  handleKeyDown,
  taggedUsers,
  setTaggedUsers,
  multiline = false,
  rows = 1,
  padding = 0,
  backgroundColor = "transparent",
  setTaggingPopoverOpen,
}) => {
  const isMobileDisplay = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  const inputRef = useRef(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleChange = (e) => {
    const newValue = e.target.value;
    const cursorPosition = e.target.selectionStart;
    handleInputChange(newValue);

    const textBeforeCursor = newValue.slice(0, cursorPosition);
    const match = textBeforeCursor.match(/@([\w\s]*)$/);
    if (match) {
      const [, searchTerm] = match;
      const filtered = tagUserList.filter((user) =>
        user.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredUsers(filtered);
      setAnchorEl(filtered.length ? inputRef.current : null);
      setTaggingPopoverOpen(filtered.length > 0);
    } else {
      setAnchorEl(null);
      setTaggingPopoverOpen(false);
    }

    const remainingTags = taggedUsers.filter((tag) => newValue.includes(`@${tag.name}`));
    if (remainingTags.length !== taggedUsers.length) {
      setTaggedUsers(remainingTags);
    }
  };

  const handleTagSelect = (user) => {
    const cursorPosition = inputRef.current.selectionStart;
    const textBeforeCursor = value.slice(0, cursorPosition);
    const textAfterCursor = value.slice(cursorPosition);

    const updatedTextBeforeCursor = textBeforeCursor.replace(/@([\w\s]*)$/, `@${user.name} `);
    const newText = updatedTextBeforeCursor + textAfterCursor;

    if (!taggedUsers.some((tag) => tag.id === user.id)) {
      setTaggedUsers([...taggedUsers, user]);
    }

    handleInputChange(newText);
    setAnchorEl(null);
    setTaggingPopoverOpen(false);

    // let the state update before setting the cursor position
    setTimeout(() => {
      const newCursorPosition = updatedTextBeforeCursor.length;
      inputRef.current.setSelectionRange(newCursorPosition, newCursorPosition);
      inputRef.current.focus();
    }, 0);
  };

  return (
    <Box width="100%" alignContent="center" position="relative">
      <TextField
        fullWidth
        multiline={multiline}
        minRows={rows}
        maxRows={6}
        placeholder="Give kudos!"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        inputRef={inputRef}
        sx={{
          backgroundColor,
          padding,
          border: "none",
          borderRadius: "0.5rem",
          "& .MuiInputBase-input": {
            color: "#ddd9d5",
            fontSize: "1rem",
            p: 0,
          },
          "& .MuiOutlinedInput-root": {
            p: 0,
            border: "none",
            "& fieldset": {
              border: "none",
            },
            "&:hover fieldset": {
              border: "none",
            },
            "&.Mui-focused fieldset": {
              border: "none",
            },
          },
        }}
      />
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="top-start"
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 10],
            },
          },
        ]}
        sx={{ overflow: "hidden" }}
      >
        <TagUserPopover
          handleUserClick={handleTagSelect}
          filteredUsers={filteredUsers}
          isMobileDisplay={isMobileDisplay}
          handleClose={() => {
            setAnchorEl(null);
            setTaggingPopoverOpen(false);
          }}
        />
      </Popper>
    </Box>
  );
};

export default TaggingTextField;
